import { CONTRAST_LIGHT } from '@kissui/components'
import { NespressoElement } from '@kissui/components/src/nespressoElement'
import './components/cup-size'

class CupSizes extends NespressoElement {
    loadTemplate() {
        const { layout, campaign, copywriting } = this.props
        const { padding_top, padding_bottom, background_color } = layout
        const { heading, description, items } = copywriting

        if (!items) {
            return null
        }

        this.template = `<nb-container
                background_color='${background_color}'
                contrast='${CONTRAST_LIGHT}'
                classname='${padding_top} ${padding_bottom}'
                campaign_id='${campaign.id}'
                campaign_name='${campaign.name}'
                campaign_position='${campaign.position}'
                campaign_creative='${campaign.creative}'>
                <h2 class='h-3xl-300'>${heading}</h2>
                <p class='cb-description t-sm-400'>${description}</p>
                <div class='cb-items'>
                ${items
                    .map(data => `<nb-cup-size data='${JSON.stringify(data)}'></nb-cup-size>`)
                    .join('')}
                </div>
            </nb-container>`

        this.render()
    }
}

customElements.get('nb-cup-sizes') || customElements.define('nb-cup-sizes', CupSizes)

export default CupSizes
